import React from 'react';
import _ from 'lodash';

import { useAppleCareWidgetQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IAppleCareAgreement {
  id: string;
  agreementNumber: string;
  serialNumber: string;
  expiresAt: DateTime | null;
}

export interface IData {
  agreements: IAppleCareAgreement[];
}

export function useQuery(orderId: string) {
  const queryTuple = useAppleCareWidgetQuery({
    variables: {
      orderId
    }
  });



  return React.useMemo(
    () => {
      const agreements = _.compact(_.map(queryTuple.data?.order?.lineItems, lineItem => lineItem.appleCareAgreement));
      const data: IData = {
        agreements: _.map(agreements, (agreement): IAppleCareAgreement => ({
          id: agreement.id,
          expiresAt: agreement.expiresAt ? DateTime.fromISO(agreement.expiresAt) : null,
          agreementNumber: agreement.agreementNumber,
          serialNumber: agreement.serialNumber
        }))
      };

      return {
        ...queryTuple,
        data
      };
    },
    [queryTuple]);
}
